import { Track, Poster, MediaPlayer, MediaProvider, MediaPlayerInstance } from '@vidstack/react';
import { DefaultVideoLayout, defaultLayoutIcons } from '@vidstack/react/player/layouts/default';
import '@vidstack/react/player/styles/default/layouts/audio.css';
import '@vidstack/react/player/styles/default/layouts/video.css';
import '@vidstack/react/player/styles/default/theme.css';
import React, { useRef } from 'react';

type TextTrackKind = 'subtitles' | 'captions' | 'descriptions' | 'chapters' | 'metadata';

interface TrackProps {
  src: string;
  kind: TextTrackKind;
  label: string;
  language: string;
  default?: boolean;
}

interface MediaPlayerComponentProps {
  src: string;
  viewType: 'video' | 'audio';
  streamType: 'on-demand' | 'live';
  logLevel?: 'silent' | 'error' | 'warn' | 'info' | 'debug';
  crossOrigin?: true | 'anonymous' | 'use-credentials' | null;
  playsInline?: boolean;
  title: string;
  poster: string;
  textTracks: TrackProps[];
}

const MediaPlayerComponent: React.FC<MediaPlayerComponentProps> = ({
  src,
  viewType,
  streamType,
  logLevel = 'warn',
  crossOrigin = true,
  playsInline = true,
  title,
  poster,
  textTracks,
}) => {
  const player = useRef<MediaPlayerInstance>(null);

  return (
    <MediaPlayer
      src={src}
      viewType={viewType}
      ref={player}
      streamType={streamType}
      logLevel={logLevel}
      crossOrigin={crossOrigin}
      muted
      controls={false}
      playsInline={playsInline}
      title={title}
      poster={poster}
    >
      <MediaProvider>
        <Poster className="vds-poster" />
        {textTracks.map((track) => (
          <Track {...track} key={track.src} />
        ))}
      </MediaProvider>
      <DefaultVideoLayout
        thumbnails="https://files.vidstack.io/sprite-fight/thumbnails.vtt"
        icons={defaultLayoutIcons}
      />
    </MediaPlayer>
  );
};

export default MediaPlayerComponent;
